import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import Cards from "./Components/Cards";
import { Label } from "reactstrap";
import { Services } from './Services'
import ClientesList from '../../../services/storageClient'
import Loader from './../../Global/Loader'


import axios from 'axios';
const clientSave = new ClientesList();

class QuickSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientesSelect: clientSave.getAuthentication('client'),
      results: [],
      path: "",
      fullLoader: false

    };
  }

  componentDidMount = () => {
    this.setState({ path: this.props.match.params.id }, () => this.getQuickSearch())
  };

  componentWillReceiveProps = nextProps => {
    this.setState({
      path: nextProps.match.params.id,
      fullLoader: false
    }, () => this.getQuickSearch())
  };

  getQuickSearch = () => {
    const { path } = this.state
    let timeStart
    timeStart = Date.now();
    const data = {
      cliente: this.state.clientesSelect
    }
    // console.log("path", path, this.state.fullLoader);
    axios.post(`${Services.Get_QuickSearch.path}quicksearch?q=${path}`, data).then((response) => {
      // console.log("response----<", response.data)
      this.setState({
        data: response.data.message,
        sizeRes: response.data.message.Total,
        fullLoader: true
      });
    }).catch((error) => {
      console.log('ERROR', error);
    });

    this.setState({ timeStart })
  };

  render() {
    const { timeStart, data, path, sizeRes, fullLoader } = this.state;
    const timeEnddd = Date.now()
    const timeValue = (timeEnddd - timeStart) / 1000

    return (
      <ContentWrapper>
        <Loader hidden={fullLoader} />
        <Label>Total results: {sizeRes}  ({timeValue} seconds) for  <b> "{path}" </b></Label>
        <Cards data={data} />
      </ContentWrapper>
    );
  }
}
export default withRouter(QuickSearch);
